import {
  DEFAULT_DELAY_TIME,
} from '@/config/constants'

// TODO: Delete and hope for the best
class RequestQueue {
  constructor () {
    this.queue = []
    this.errors = []
    this.results = []
    this.running = false
  }

  /**
   *
   * Process which runs all queued requests consecutively.
   *
   * @param {any} data
   * @returns {boolean}
   * @private
   */
  $_process (data) {
    if (this.running) {
      return false
    }

    let next = this.queue.shift()
    if (!next) {
      return false
    }

    this.running = true

    next.run(data)
      .then(value => {
        this.running = false
        next.resolve(value)
        setTimeout(() => this.$_process(value), DEFAULT_DELAY_TIME / 2)
      })
      .catch(error => {
        this.running = false
        next.reject(error)
        setTimeout(() => this.$_process(data), DEFAULT_DELAY_TIME / 2)
      })
    return true
  }

  /**
   *
   * @param {Function} callback  A function which wraps the real request call / promise for executes it
   * @returns {Promise<unknown>}
   */
  add (id, callback) {
    if (callback instanceof Promise) {
      throw new Error('You need to wrap your request call / promise in a function.')
    }
    return new Promise((resolve, reject) => {
      this.queue.push({
        id,
        run: callback,
        resolve: resolve,
        reject: reject
      })

      this.$_process()
    })
      .then(result => {
        this.results.push(result)
        return result
      })
      .catch(error => {
        this.errors.push(error)
        return Promise.reject(error)
      })
  }
}

export default {
  queues: {},

  getQueue (id) {
    if (!this.queues[id]) {
      this.queues[id] = new RequestQueue()
    }
    return this.queues[id]
  }
}
